import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    previousRouteName: null,
    sectionEntryRouteName: null,
    pendingRealFrom: null,
  }),
  actions: {
    setPreviousRoute(name) {
      this.previousRouteName = name;
    },
    setSectionEntryRoute(name) {
      this.sectionEntryRouteName = name;
    },
    setPendingRealFrom(route) {
      this.pendingRealFrom = route;
    },
  },
});
